<template>
  <div class="menuandvideo1">
    <div class="title_msg1">
        <div  v-for="(item,index) in roomtaglsit" :key="index">
            <div :class="menu_choose == item.tagType ? 'is_choose1':'not_choose1'" @click="menu_choose=item.tagType">
                {{item.title}}
                <div v-if="menu_choose == item.tagType" class="line1"></div>
            </div>
        </div>
    </div>
    <div>
        <videos v-if="menu_choose==3"></videos>
        <evaluate v-if="menu_choose==5"></evaluate>
        <div v-if="menu_choose ==6" v-html="live_content" style="padding: 20px 50px;" class="detail_xq"></div>
        <iframe  v-if="menu_choose==7" :src="open_url" frameborder="0" style="width: 100%;height:100vh;" scrolling="yes"></iframe>
        <div v-if="menu_choose ==9" v-html="text_img" style="padding:20px 50px;" class="detail_xq"></div>
    </div>
  </div>
</template>

<script>
import evaluate from "./evaluate.vue"
import videos from "./videos.vue"
export default {
  name: 'menuandvideo',
  components:{
    evaluate,
    videos
  },
  props: {
    roomtaglsit:Array,
    livedetail:Object
  },
  created() {
    
  },
  mounted() {
    for(var i in this.roomtaglsit){
       if (this.roomtaglsit[i].tagType == 2){}
       if (this.roomtaglsit[i].tagType == 3){
       }
       if (this.roomtaglsit[i].tagType == 4){}
       if (this.roomtaglsit[i].tagType == 5){}
       if (this.roomtaglsit[i].tagType == 6){
        this.live_content =  this.livedetail.content
       }
       if (this.roomtaglsit[i].tagType == 7){

        this.open_url = this.roomtaglsit[i].content
       }
       if (this.roomtaglsit[i].tagType == 9){
        this.text_img =  this.roomtaglsit[i].content
       }
       if (this.roomtaglsit[i].tagType == 99){}
    }
  },
  data() {
    return {
        islist:[
        ],
        menu_choose:this.roomtaglsit[0].tagType,
        open_url:'',
        text_img :'',
        live_content:''
    }
  },
  methods: {
  },
 
}
</script>
<style>
.menuandvideo1{
    margin: 20px auto;
    width: 90vw;
    background: #FFFFFF;
    border-radius: 12px;
}
.title_msg1{
    height: 62px;
    border-bottom: 1px solid #ECECEC;
    font-size: 20px;
}
.is_choose1{
    float: left;
    margin-left: 60px;
    margin-top: 8px;
    height: 49px;
    line-height: 51px;
    color: #333333;
    width: 80px;
}
.not_choose1{
    float: left;
    margin-left: 60px;
    margin-top: 8px;
    height: 49px;
    line-height: 51px;
    color: #555555;
    width: 80px;
}
.line1{
    width: 80px;
    height: 4px;
    background: linear-gradient(153deg, #04BAF3 0%, #256EE7 96%);
    }
img{
   max-width: 100%;
  }
  .detail_xq{
    text-align: left;
  }
</style>
